import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { timeout } from 'rxjs/operators';
import { ENV } from '@app/env';
import { Utils } from '../utils/utils';

/*
*
*  Api Provider
*
*/
@Injectable()
export class Api {

    private DEFAULT_EXPIRE : number = 180000;
    public _logs : any = [];

    constructor(
        public httpClient: HttpClient,
        public utils: Utils
    ) { 
    }

    getApiURL () {
        if (localStorage.getItem('hookAPIURL') && localStorage.getItem('hookAPIURL') != 'null' && localStorage.getItem('hookAPIURL') != null) {
            return localStorage.getItem('hookAPIURL');
        } else {
            return ENV.api;
        }
    }

    getCached(endpoint: string, params?: any, headers? : any, expireTime? :any) : Observable<any> {

        let _prefix = 'api/';

        if (!params) params = {};

        if (endpoint.length && endpoint[0] == '/') {
            endpoint = endpoint.substr(1);
        }

        // Check if there is a cache 
        if (localStorage.getItem(_prefix+endpoint) && !params.writeCache) {

            let _data = localStorage.getItem(_prefix+endpoint);

            if (params) {
                endpoint += '?';
                for (let k in params) {
                    if (k == 'writeCache') continue;
                    endpoint+= k+'='+params[k]+'&';
                }
                if (endpoint.length && endpoint[endpoint.length-1] == '?') {
                    endpoint = endpoint.slice(0, -1);
                }
            } 

            let _observable = new Observable(observer => {
                observer.next(JSON.parse(_data));
                observer.complete();
            });

            this.log({   
               'method'   : 'CACHE',
               'endpoint' : '/'+endpoint
            });

            return _observable;

        } else {
            let _observable = new Observable(observer => {

                this.get(endpoint, params, headers, expireTime).subscribe((response:any)=>{
                    localStorage.setItem(_prefix+endpoint, JSON.stringify(response));
                    observer.next(response);
                    observer.complete();
                }, (err) => {
                    observer.error(err);
                });
                
            });

            return _observable;
        }

    }

    get(endpoint: string, params?: any, headers? : any, expireTime? :any) {
        if (params) {
            endpoint += '?';

            for (let k in params) {
                if (k == 'writeCache') continue;
                endpoint+= k+'='+params[k]+'&';
            }
        } 

        if (endpoint.length && endpoint[0] == '/') {
            endpoint = endpoint.substr(1);
        }
        
        if (endpoint.length && endpoint[endpoint.length-1] == '?') {
            endpoint = endpoint.slice(0, -1);
        }

        let _request = this.httpClient.get(this.getApiURL()+'/'+endpoint, ( headers ? headers : this.getTokenHeader())).pipe(timeout(this.getTimeout(expireTime)));

        this.log({   
            'method'   : 'GET',
            'endpoint' : '/'+endpoint
        });

        return _request;
    }

    post(endpoint: string, params?: any, expireTime? :any) {

        let _request = this.httpClient.post(this.getApiURL()+'/'+endpoint, params, this.getTokenHeader()).pipe(timeout(this.getTimeout(expireTime)));
        this.log({   
            'method'   : 'POST',
            'endpoint' : '/'+endpoint
        });

        return  _request;
    }

    put(endpoint: string, params?: any, expireTime? :any) {

        let _request = this.httpClient.put(this.getApiURL()+'/'+endpoint, params,this.getTokenHeader()).pipe(timeout(this.getTimeout(expireTime)));
        
        this.log({   
            'method'   : 'PUT',
            'endpoint' : '/'+endpoint
        });

        return  _request;
    }

    delete(endpoint: string, params?: any, expireTime? :any) {

        let _request = this.httpClient.delete(this.getApiURL()+'/'+endpoint, this.getTokenHeader()).pipe(timeout(this.getTimeout(expireTime)));

        this.log({   
            'method'   : 'DELETE',
            'endpoint' : '/'+endpoint
        });

        return  _request;
    }

    getTimeout(expireTime?:any) {
        //if (expireTime) return expireTime;
        return this.DEFAULT_EXPIRE;
    }

    getTokenHeader() {
        var token = '';

        if (localStorage.getItem('token') !== null) {
            token = localStorage.getItem('token');
        }

        if (!token) return;

        return {
            headers: {'X-BS-Auth-Token':token}
        };
    }

    reject(err?:any) {

        if (err && err.errorMessage) 
            return err.errorMessage;
        if (err && err.error && err.error.errorMessage) 
            return err.error.errorMessage;
        else if (err && err.error && err.error.result && err.error.result.error && err.error.result.errorMessage)
            return err.error.result.errorMessage;
        else if (err && err.result && err.result.errorMessage)
            return err.result.errorMessage;
        else if (err && err.error && err.error.msg)
            return err.error.msg;
        else 
            return 'Internal server error';
    }

    log(params:any) {
        if (params.method == 'CACHE') {
            //this.utils.log(params.method+' '+params.endpoint,'warn');
        } else {
            //this.utils.log(params.method+' '+params.endpoint,'warn');
        }
    }

    clearCache() {
        var token   = localStorage.getItem('token');
        var hookapi = localStorage.getItem('hookAPIURL');

        localStorage.clear();
        
        localStorage.setItem('token',token);
        
        if (hookapi) {
            localStorage.setItem('hookAPIURL',hookapi);
        }
    }
}







// WEBPACK FOOTER //
// ./src/providers/api/api.ts